import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { ErrorBoundary } from './app/ErrorBoundary'
import { shouldRegisterServiceWorker } from './lib/serviceWorker'
import { AppProvider } from './state/AppProvider'
import './styles/base.css'

const mount = document.getElementById('root')

if (!mount) {
  throw new Error('The Paradox Tour Companion root element is missing.')
}

createRoot(mount).render(
  <StrictMode>
    <ErrorBoundary>
      <AppProvider>
        <App />
      </AppProvider>
    </ErrorBoundary>
  </StrictMode>,
)

const viteDevClientPresent = Boolean(document.querySelector('script[src*="/@vite/client"]'))

if (shouldRegisterServiceWorker({
  serviceWorkerSupported: 'serviceWorker' in navigator,
  viteDevClientPresent,
})) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`, {
      scope: import.meta.env.BASE_URL,
    })
  })
}
